/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
import { Component, ViewChild , Output, EventEmitter} from '@angular/core';
import { GtinValidationSetService } from 'app/services/gtin-validation-set.service';
import { GtinValidationSetDetail } from "app/models/gtin-validation-set-detail";
import { GtinValidationSetDto  } from "app/models/gtin-validation-set.dto";
import { GtinValidationSetDetailValuesDto  } from "app/models/gtin-validation-set.dto";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "../simple-success-error-dialog-box/simple-success-error-dialog-box.component";

/** Declare $ to call bootstrap */
declare var $: any;

@Component({
    selector: 'app-edit-view-gtin-dialog',
    templateUrl: './edit-view-gtin-validation-set.dialog.component.html',
    styleUrls: ['../../../assets/css/infrastructure.css']
})
export class EditViewGtinValidationSetDialogComponent {
/** Holds whether the UI should be disabled or not */
  isUiDisabled = false;
  name: string = '';
  gtin14: string = '';
  percentageUnder: number | string = '';
  percentageOver: number | string = '';
  mGtinValidationSetDto: GtinValidationSetDto;
  mGtinValidationSetDetailValuesDto: GtinValidationSetDetailValuesDto;

  /** GTIN Validation Sets being displayed in the UI */
    editgtinDetails: GtinValidationSetDetail = new GtinValidationSetDetail();

    /** Reference to the SimpleSuccessErrorDialog used to display error */
      @ViewChild('successErrorDialog') 
      simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

      @Output() refreshParent = new EventEmitter<void>();
      

    /** Constructor */
    constructor(
        private gtinService: GtinValidationSetService
    ) { }

     /** Show dialog with given GTIN details */
    public show(gtinDetails: GtinValidationSetDetail, name: string): void {
        // Reset the UI
        this.name = name;
        this.editgtinDetails = gtinDetails;
        $("#editViewGtinDialog").modal("show");
    }

    /**
     * Called when the "Cancel" UI Button is clicked.
     * Cancels / Hides the Dialog.
    */
    onCancelClicked(): void {
        this.hide();
    }

    /**
     * Hides the Dialog
     */
    public hide(): void {
        $("#editViewGtinDialog").modal("hide");
    }

    //create and update API call
    createOrUpdateGtinSetDetails(): void {
        if (this.editgtinDetails.gtin14 != null) {
            if (this.editgtinDetails.maxPercentage != null || this.editgtinDetails.minPercentage != null) {
                if (this.editgtinDetails.id == null) {

                    const gtinValues: { [gtin: string]: GtinValidationSetDetailValuesDto } = {};
                    gtinValues[this.editgtinDetails.gtin14] = {
                        min_percentage: Number(this.editgtinDetails.minPercentage),
                        max_percentage: Number(this.editgtinDetails.maxPercentage)
                    };

                    const dto: GtinValidationSetDto = {
                        name: this.name, 
                        gtin_values: gtinValues
                    };
                    
                    this.gtinService.createDetailSet(dto).then(
                        response => {
                            $("#editViewGtinDialog").modal("hide");
                            this.refreshParent.emit();
                            this.hide();

                        },
                        error => {
                            console.log("Error: " + error);
                            this.handleError(error);
                        }
                    );

                } else {
                    this.gtinService.updateDetailSet(this.editgtinDetails).then(
                        response => {
                            this.hide();
                            
                        },
                        error => {
                            console.log("Error: " + error);
                            this.handleError(error);
                        }
                    );
                }
            } else {
                this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, "Please enter either Percentage Under or Percentage Over");
            }
        } else {
            this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, "Please enter GTIN 14");
        }

    }

    /**
   * Displays the error to the User
   */
  handleError(error: any): void {
    /* New handling (TJB 04/18/2023) */
    if (error?.error != null) {
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.error);
    } 
    
    /* Default back to old handling */
    else if (error != null) {
      const response: Response = error;
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.text);
    }
  }

}